// src/utils/normalize.js

export function normalizeKey(input) {
  if (!input || typeof input !== 'string') return '';

  const canonicalModes = {
    major: 'major',
    maj: 'major',
    minor: 'minor',
    min: 'minor',
    dorian: 'dorian',
    dor: 'dorian',
    mixolydian: 'mixolydian',
    mix: 'mixolydian',
  };

  const rootRegex = /^(c#|cb|c|d#|db|d|e#|eb|e|f#|fb|f|g#|gb|g|a#|ab|a|b#|bb|b)/i;
  const lowered = input.trim().toLowerCase().replace(/\s+/g, '');

  const rootMatch = lowered.match(rootRegex);
  if (!rootMatch) return input.trim();

  const rawRoot = rootMatch[0];
  const rest = lowered.slice(rawRoot.length);

  const rootMap = {
    'bb': 'Bb', 'ab': 'Ab', 'eb': 'Eb', 'db': 'Db', 'gb': 'Gb', 'cb': 'Cb', 'fb': 'Fb',
    'f#': 'F#', 'c#': 'C#', 'g#': 'G#', 'd#': 'D#', 'a#': 'A#', 'e#': 'E#', 'b#': 'B#',
    'b': 'B', 'a': 'A', 'c': 'C', 'd': 'D', 'e': 'E', 'f': 'F', 'g': 'G'
  };

  const root = rootMap[rawRoot] || rawRoot.toUpperCase();

  if (!rest) return `${root} major`;

  const canonicalMode = canonicalModes[rest];
  if (canonicalMode) {
    return `${root} ${canonicalMode}`;
  }

  return `${root} ${rest.toLowerCase()}`;
}


export function normalizeType(raw) {
  if (!raw) return '';
  return raw
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .split(' ')
    .map(word => word
      .split('-')
      .map(segment => (segment ? segment.charAt(0).toUpperCase() + segment.slice(1) : segment))
      .join('-')
    )
    .join(' ');
}


export function keyRoot(normalizedKey) {
  const raw = (normalizedKey || '').trim();

  // Match longest valid accidental-based root first
  const match = raw.match(/^(C#|Db|D#|Eb|E#|Fb|F#|Gb|G#|Ab|A#|Bb|B#|Cb|C|D|E|F|G|A|B)/i);

  return match ? match[1].replace(/^\w/, c => c.toUpperCase()) : '';
}

const genreOverrides = {
  'old time': 'Old-Time',
  'old-time': 'Old-Time',
  'bluegrass': 'Bluegrass',
  'irish': 'Irish',
  'r&b': 'R&B',
  'singer songwriter': 'Singer-Songwriter',
};

export function normalizeGenre(genre) {
  if (!genre) return '';
  const clean = String(genre)
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, ' ')
    .replace(/\s*-\s*/g, '-');
  if (!clean) return '';
  const lookup = clean.replace(/-/g, ' ');
  if (genreOverrides[clean]) return genreOverrides[clean];
  if (genreOverrides[lookup]) return genreOverrides[lookup];
  return clean
    .split('-')
    .map((part) => part.replace(/\b\w/g, (c) => c.toUpperCase()))
    .join('-');
}

export function getNormalizedGenreOptions(values = []) {
  const seen = new Map();
  values.forEach((value) => {
    const normalized = normalizeGenre(value);
    if (!normalized) return;
    const key = normalized.toLowerCase();
    if (!seen.has(key)) seen.set(key, normalized);
  });
  return [...seen.values()].sort((a, b) => a.localeCompare(b));
}


export const normalizeTag = (tag) => tag.trim().toLowerCase();

export const normalizeTagsArray = (tags) => {
  return [...new Set(tags.map(normalizeTag).filter(tag => tag.length > 0))];
};
